/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HistoryExportRequest } from '../../models/history-export-request';

export interface PostApiCustomerV1IdHistoryExport$Plain$Params {
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: HistoryExportRequest
}

export function postApiCustomerV1IdHistoryExport$Plain(http: HttpClient, rootUrl: string, params: PostApiCustomerV1IdHistoryExport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, postApiCustomerV1IdHistoryExport$Plain.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

postApiCustomerV1IdHistoryExport$Plain.PATH = '/private/v1/customers/{id}/history-export';
